import * as React from "react";

interface FilterContextType {
  filterByCulture: (culture: string) => void;
}

const FilterContext = React.createContext<FilterContextType | null>(null);

export const FilterProvider: React.FC<{
  children: React.ReactNode;
  onFilterByCulture: (culture: string) => void;
}> = ({ children, onFilterByCulture }) => {
  return (
    <FilterContext.Provider value={{ filterByCulture: onFilterByCulture }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => {
  const context = React.useContext(FilterContext);
  if (!context) {
    return null;
  }
  return context;
};
